import React from 'react';

import { connect } from 'react-redux';

import { tripSummarySelectors } from 'wanderu-ducks-search';
import { tripSelectors } from 'wanderu-ducks-trips';
import { selectLocale } from 'wanderu-i18n';

import TripSummaryLine from '../../components/TripSummary/TripSummaryLine/TripSummaryLine';

function TripSummaryLineComponent(props) {
    return (
        <TripSummaryLine {...props} />
    );
}

function mapStateToProps(state, ownProps) {
    const {
        tripId,
        seats,
        wheelchairs,
    } = ownProps;

    const trips = tripSelectors.selectTripSet(state, tripId);
    const departLeg = trips[0];
    const arriveLeg = trips[trips.length - 1];
    const arrive = tripSelectors.selectTripArriveData(state, arriveLeg.tripId);
    const depart = tripSelectors.selectTripDepartData(state, departLeg.tripId);
    const itinerary = tripSummarySelectors.selectItinerary(state, tripId);

    const availableFares = tripSummarySelectors.selectAvailableFares(
        state,
        tripId,
        seats,
        wheelchairs,
    ) || {};

    const carrierProviderGroup = tripSummarySelectors.selectServiceAttribution(state, [tripId]);

    return {
        arrive,
        availableFares: availableFares[tripId],
        carrierProviderGroup,
        depart,
        itinerary,
        locale: selectLocale(state),
        trips,
    };
}

export {
    mapStateToProps,
};
export default connect(mapStateToProps)(TripSummaryLineComponent);
